// extracted by mini-css-extract-plugin
export var bodyContainer = "ProductCard-module--bodyContainer--hh70A";
export var card = "ProductCard-module--card---ptW4";
export var ctas = "#226355";
export var description = "ProductCard-module--description--upKDG";
export var grayBackground = "#f6f8fb";
export var imageContainer = "ProductCard-module--imageContainer--Gpnch";
export var title = "ProductCard-module--title--mSt4Z";